import React, { useEffect } from 'react';

// Full-screen PDF viewer that masks the background; used by the estimate View actions.
const PdfViewerModal = ({ url, onClose, title = 'Estimate Preview' }) => {
  useEffect(() => {
    if (!url) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [url, onClose]);

  if (!url) return null;

  return (
    <div className="fixed inset-0 z-50 flex flex-col overflow-hidden bg-gray-800 bg-opacity-90" onClick={onClose}>
      <div className="flex items-center justify-between px-4 py-2">
        <span className="text-white text-sm font-semibold">{title}</span>
        <button
          onClick={onClose}
          className="px-3 py-1.5 rounded-md text-sm font-semibold bg-white text-gray-800 shadow hover:bg-gray-100"
        >
          ✕ Close
        </button>
      </div>
      <div className="flex-1 min-h-0 mx-auto w-full max-w-3xl px-2 pb-2" onClick={(e) => e.stopPropagation()}>
        <iframe title={title} src={`${url}#toolbar=0`} className="block w-full h-full rounded-md bg-white shadow-lg" />
      </div>
    </div>
  );
};

export default PdfViewerModal;
